import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75feb6b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-8 flex justify-between" }
const _hoisted_2 = {
  class: "flex",
  "aria-label": "Breadcrumb"
}
const _hoisted_3 = {
  role: "list",
  class: "flex items-center space-x-4"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "16",
  viewBox: "0 0 17 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.8337 12.9163C10.1674 13.435 9.29216 13.7497 8.33366 13.7497C7.37508 13.7497 6.49992 13.435 5.83365 12.9163M0.833496 8.74101V10.833C0.833496 13.5828 0.833496 14.9578 1.68777 15.8121C2.54204 16.6663 3.91697 16.6663 6.66683 16.6663H10.0002C12.75 16.6663 14.1249 16.6663 14.9792 15.8121C15.8335 14.9578 15.8335 13.5828 15.8335 10.833V8.74101C15.8335 7.33992 15.8335 6.63945 15.5369 6.03305C15.2403 5.42665 14.6874 4.99657 13.5815 4.13643L11.9148 2.84013C10.1944 1.50205 9.33425 0.833008 8.3335 0.833008C7.33275 0.833008 6.47257 1.50205 4.75218 2.84013L3.0855 4.13643C1.9796 4.99657 1.42665 5.42665 1.13008 6.03305C0.833496 6.63945 0.833496 7.33992 0.833496 8.74101Z",
    stroke: "#667085",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Home", -1))
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["aria-current"]
const _hoisted_8 = {
  key: 0,
  class: "flex flex-row gap-3 z-[100]"
}

import { useDataStore } from '@/stores/dataStore';
import { useUserStore } from '@/stores/userStore';
import { useFilterStore } from '@/stores/filterStore';
import { useSchoolStore } from '@/stores/schoolStore';
import { ArrowPathIcon, ChevronRightIcon } from '@heroicons/vue/24/outline';
import { computed, watch } from 'vue';

interface Page {
  name: string;
  path?: string;
}

interface Props {
  pages: Page[];
  hideFilters: boolean;
  highlightLast?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PageTitleComponent',
  props: {
    pages: {},
    hideFilters: { type: Boolean },
    highlightLast: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const dataStore = useDataStore();
const userStore = useUserStore();
const filterStore = useFilterStore();
const schoolStore = useSchoolStore();

const homePath = computed(() =>
  schoolStore.lingoMode === "v2" && schoolStore.isEnglishOnlySchool
    ? "/main/lingo-data"
    : "/main/overview"
);



// Watch for changes to the selected school and trigger a data fetch
watch(
  () => filterStore.selectedFilters.school,
  (newSchoolId, oldSchoolId) => {
    if (newSchoolId) {
      // Call selectSchool to handle grade/classGroup reset consistently
      if (newSchoolId !== oldSchoolId) {
        filterStore.selectSchool(newSchoolId);
      }

      dataStore.fetchInitialData();
    }
  }
);

// Watch for changes to the selected school group and update the school
watch(
  () => filterStore.selectedFilters.schoolGroup,
  (newSchoolGroupId) => {
    if (newSchoolGroupId) {
      const schoolGroup = filterStore.filterOptions?.schoolGroups.find(sg => sg._id === newSchoolGroupId);
      if (schoolGroup && schoolGroup.schools.length > 0) {
        // Automatically select the first school
        filterStore.selectedFilters.school = schoolGroup.schools[0]._id;
      } else {
        // Reset school if school group has no schools
        filterStore.selectedFilters.school = '';
      }
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ol", _hoisted_3, [
        _createElementVNode("li", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: homePath.value,
              class: "text-gray-400 hover:text-gray-500"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.pages, (page, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: page.name
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(ChevronRightIcon), {
                class: "h-3 w-3 shrink-0 text-gray-400",
                "aria-hidden": "true"
              }),
              (page.path && page.path !== '#' && idx !== props.pages.length - 1)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: page.path,
                    class: "ml-4 text-sm font-medium text-gray-600 hover:text-gray-700",
                    style: {"font-family":"'Poppins', sans-serif","letter-spacing":"0"},
                    "data-testid": "breadcrumb-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(page.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["ml-4 text-sm font-medium text-gray-600", { 'breadcrumb-last-highlight': props.highlightLast && idx === (props.pages.length - 1) }]),
                    style: {"font-family":"'Poppins', sans-serif","letter-spacing":"0"},
                    "aria-current": idx === (props.pages.length - 1) ? 'page' : undefined,
                    "data-testid": "breadcrumb-current"
                  }, _toDisplayString(page.name), 11, _hoisted_7))
            ])
          ]))
        }), 128))
      ])
    ]),
    (!_ctx.hideFilters)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_unref(filterStore).schoolGroupOptions.length > 1 && _unref(userStore).isInternalAdmin)
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 0,
                type: "search",
                name: "selectedSchoolGroup",
                placeholder: 'Select School Group',
                searchOptions: _unref(filterStore).schoolGroupOptions,
                modelValue: _unref(filterStore).selectedFilters.schoolGroup,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filterStore).selectedFilters.schoolGroup) = $event))
              }, null, 8, ["searchOptions", "modelValue"]))
            : _createCommentVNode("", true),
          (_unref(userStore).isInternalAdmin || _unref(userStore).isSchoolGroupAdmin || _unref(userStore).isMultipleSchoolAdmin)
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 1,
                type: "search",
                name: "selectedSchool",
                placeholder: 'Select School',
                searchOptions: _unref(filterStore).schoolOptions,
                modelValue: _unref(filterStore).selectedFilters.school,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filterStore).selectedFilters.school) = $event))
              }, null, 8, ["searchOptions", "modelValue"]))
            : _createCommentVNode("", true),
          (_unref(userStore).isInternalAdmin || _unref(userStore).isSchoolGroupAdmin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg flex flex-row items-center gap-1.5",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(dataStore).fetchNewData && _unref(dataStore).fetchNewData(...args)))
              }, [
                _createVNode(_unref(ArrowPathIcon), {
                  class: "-ml-0.5 h-5 w-5",
                  "aria-hidden": "true"
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})